"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const initialState = {
    chartTitle: "",
    chartLabels: [],
    chartDataList: [],
    chartCategory: "",
    comparePossible: false,
    setChartsData: {},
    getChartsData: {},
    removeChartsData: {},
    setComparePossible: {},
    removeChartsDataByLabel: {},
};
exports.default = (0, react_1.createContext)(initialState);
